<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div
        style="display: flex"
        class="mbl-gen justify-content-between align-items-center"
      >
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/generation.svg" />
          </div>
          <div>
            <div class="card_title_1">BUDGET</div>
            <!-- <div class="card_title_2">Last Updated {{ last_update }}</div> -->
          </div>
        </div>
        <div>
          <!-- <select class="form-select custom_select" style="color: #838383">
            <option value="all" selected>Select UID</option>
            <option>1111</option>
            <option>2222</option>
          </select> -->
          <select v-model="uuid" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUuid"
              :key="key"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-3 gm-mobile">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[0]"
            :selected="
              selectedCard.metricId === dataBudget.investments[0].metricId
            "
            @click="selectCard(dataBudget.investments[0])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3 gm-mobile">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[1]"
            :selected="
              selectedCard.metricId === dataBudget.investments[1].metricId
            "
            @click="selectCard(dataBudget.investments[1])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3 gm-mobile">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[2]"
            :selected="
              selectedCard.metricId === dataBudget.investments[2].metricId
            "
            @click="selectCard(dataBudget.investments[2])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3 gm-mobile">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[3]"
            :selected="
              selectedCard.metricId === dataBudget.investments[3].metricId
            "
            @click="selectCard(dataBudget.investments[3])"
          ></CardBudgetInvestment>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card card_white flex-fill" style="padding: 0px">
            <div class="row" style="--bs-gutter-x: 0px">
              <div class="col-4 gm-mobile">
                <CardBudgetKpi
                  style="border-right: 1px solid #e6e6e6"
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[0]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[0].metricId
                  "
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
              <div class="col-4 gm-mobile">
                <CardBudgetKpi
                  style="border-right: 1px solid #e6e6e6"
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[1]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[1].metricId
                  "
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
              <div class="col-4 gm-mobile">
                <CardBudgetKpi
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[2]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[2].metricId
                  "
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h5 style="text-transform: uppercase">
            {{ selectedCard.metricName }}
          </h5>
          <div class="prod-mobile d-flex justify-content-between">
            <div style="display: flex" class="mbl-gen card-header-right">
              <div>
                <button
                  @click="monthly"
                  class="border-period-left btn btn-disable btn-square btn-disable"
                  :class="{ 'btn-info color-active': activeClass }"
                  type="button"
                  title="btn btn-square btn-disable btn-primary"
                >
                  Monthly
                </button>
                <button
                  @click="cumulative"
                  :class="{ 'btn-info color-active': isActiveMonth }"
                  class="border-period-right btn btn-square btn-disable m-r-10 btn-disable"
                  type="button"
                  title="btn btn-square btn-primary"
                >
                  Cumulative
                </button>
              </div>
              <div>
                <select v-model="year" class="custom-dropdown form-select">
                  <option
                    v-for="(option, key) in dataYear"
                    :key="key"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                  <!-- <option>Fix price</option> -->
                </select>
              </div>
            </div>
            <div class="text-end">
              <div class="d-flex">
                <!-- <div style="margin-top: -2px" class="checkbox-solid-primary">
                  <span style="color: #ff9900; font-weight: bold">......</span>
                  <span class="m-l-5 custom_checkbox_texts">Budget</span>
                </div> -->
                <!-- <div class="legend-item m-r-10">
                  <span class="custom_checkbox_cash">Budget</span>
                  <div class="legend-symbol line-circles">
                    <div class="line"></div>
                    <div class="circle"></div>
                  </div>
                </div> -->
                <div
                  v-for="(item, id) in dataCheckbox"
                  :key="id"
                  class="m-r-10 d-flex flex-row-reverse align-items-center"
                >
                  <div
                    v-if="item.type !== 'line'"
                    class="custom_checkbox_texts"
                  >
                    {{ item.name }}
                  </div>
                  <div v-if="item.type !== 'line'">
                    <input
                      class="m-r-5 form-check-input custom_checkbox_revenue"
                      :style="{
                        backgroundColor: item.color,
                        borderColor: item.color,
                      }"
                      type="checkbox"
                      :value="item.id"
                      v-model="isCheckedBudget"
                    />
                  </div>
                  <div
                    v-if="item.type === 'line'"
                    class="custom_checkbox_texts"
                  >
                    {{ item.name }}
                  </div>
                  <div v-if="item.type === 'line'">
                    <input
                      class="m-r-5 form-check-input custom_checkbox_revenue"
                      :style="{
                        backgroundColor: item.color,
                        borderColor: item.color,
                      }"
                      type="checkbox"
                      :value="item.id"
                      v-model="isCheckedBudget"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <apexchart
            type="line"
            height="350"
            :options="barChartOptions"
            :series="barSeries"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";

import CardBudgetInvestment from "./CardBudgetInvestment.vue";
import CardBudgetKpi from "./CardBudgetKpi.vue";
import CardWhite from "./CardWhite.vue";
import CardWhiteNull from "./CardWhiteNull.vue";

const getRef = ReferenceService.build();
const apiDistribution = DistributionService.build();
export default {
  props: ["data"],
  components: {
    IconSvg,
    CardBudgetInvestment,
    CardBudgetKpi,
    CardWhiteNull,
  },
  data() {
    return {
      last_update: "",
      uuid: "reg_opdis",
      dataUuid: [],
      isCheckedM: true,
      activeClass: true,
      isCheckedJ: true,
      dataCheckbox: [],
      isCheckedBudget: [],
      year: "2024",
      dataYear: [],
      isActiveMonth: false,
      barSeries: [],
      barChartOptions: {
        chart: {
          type: "line",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
            borderRadiusWhenStacked: "all",
          },
        },
        // stroke: {
        //   width: 1,
        // },
        /*title: {
          text: "100% Stacked Bar",
        },*/
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          labels: {
            show: true,
            style: {
              colors: "#999999",
              fontFamily: "Rubik, sans-serif",
            },
          },
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: ["#999999"],
              fontFamily: "Rubik, sans-serif",
            },
          },
          title: {
            // text: "Bn IDR", di comment dlu
            style: {
              fontSize: "14px",
              color: "#999999",
            },
            rotate: 0,
            offsetX: 0,
            offsetY: -150,
          },
        },
        tooltip: {
          inverseOrder: true,
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        fill: {
          opacity: 1,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
          curve: "straight",
          dashArray: [],
        },
        legend: {
          position: "right",
          horizontalAlign: "left",
          offsetX: 40,
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
      },
      dataTemp: [],
      dataBudget: null,
      dataBudgetDetail: null,
      selectedCard: 0,
      dataTarget: [],
    };
  },
  mounted() {
    this.getDataDistributionBudget("");
    this.getRefUid();
    this.getYear();
  },
  watch: {
    isCheckedBudget(x) {
      const filter = this.dataTemp.filter((item) => x.includes(item.id));
      this.barSeries = filter;
    },
    year() {
      let params = {
        id: this.selectedCard.metricId,
        year: Number(this.year),
        type: this.isActiveMonth ? "cumulative" : "noncumulative",
        instance: this.uuid,
      };

      this.getDataDistributionBudgetDetail(params);
    },
    uuid() {
      this.getDataDistributionBudget(this.uuid);
    },
  },
  methods: {
    getYear() {
      const currentYear = new Date().getFullYear();
      const yearsArray = Array.from({ length: 5 }, (_, index) =>
        (currentYear - index).toString()
      );
      this.dataYear = yearsArray.map((year) => ({
        label: year,
        value: year,
      }));
      this.year = yearsArray[0];
    },
    async getRefUid() {
      const res = await getRef.getRefUid();
      const data = res.data.data;
      const defaults = {
        label: "All UID",
        value: "reg_opdis",
        // disabled: true,
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    monthly() {
      this.isActiveMonth = false;
      this.activeClass = true;
      let params = {
        id: this.selectedCard.metricId,
        year: Number(this.year),
        type: "noncumulative",
        instance: this.uuid,
      };

      this.getDataDistributionBudgetDetail(params);
    },
    cumulative() {
      this.isActiveMonth = true;
      this.activeClass = false;
      let params = {
        id: this.selectedCard.metricId,
        year: Number(this.year),
        type: "cumulative",
        instance: this.uuid,
      };

      this.getDataDistributionBudgetDetail(params);
    },
    selectCard(card) {
      this.selectedCard = card;
      let params = {
        id: card.metricId,
        year: Number(card.year),
        type: this.isActiveMonth ? "cumulative" : "noncumulative",
        instance: this.uuid,
      };
      this.year = card.year;
      this.dataTarget = card.target;
      this.getDataDistributionBudgetDetail(params);
    },

    updateSeries() {
      this.barSeries = this.dataBudgetDetail;
    },

    async getDataDistributionBudget(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionBudget(param);
      if (res && res.status == 200) {
        this.last_update = res.data.lastUpdate;
        this.dataBudget = res.data.data;
        const data = res.data.data.investments;
        if (res.data.data.investments.length > 0) {
          const target = data.map((obj) => obj.target);
          this.dataTarget = target[0];
          this.selectCard(res.data.data.investments[0]);
        }
      }
    },

    async getDataDistributionBudgetDetail(params) {
      let param = Object.assign({
        id: params.id,
        year: params.year,
        type: params.type,
        instance: params.instance,
      });
      try {
        const res = await apiDistribution.getDataDistributionBudgetDetail(
          param
        );
        if (res && res.status == 200) {
          const value = res.data.data;
          let dataArray = ["#164bf9", "#0dd370"];
          const result = value.map((el, index) => ({
            ...el,
            color: dataArray[index],
          }));
          const length = value[0].data.length;
          const resultArray = [];
          for (let i = 0; i < length; i++) {
            resultArray.push(this.dataTarget);
          }
          const datas = [
            {
              id: "2",
              color: "#8099D9",
              name: value.length > 2 ? value[1].name : "",
              type: "column",
              // data: value,
              data: value.length > 2 ? value[1].data : "",
            },
            {
              id: "1",
              color: "#92CAF8",
              name: value.length > 2 ? value[2].name : "",
              type: "column",
              // data: value,
              data: value.length > 2 ? value[2].data : "",
            },
            {
              id: "3",
              color: "#ff0000",
              name: value.length > 2 ? value[0].name : "",
              type: "line",
              // data: target,
              data: value.length > 2 ? value[0].data : "",
            },
          ];
          const datasOne = [
            {
              id: "1",
              color: "#92CAF8",
              name: value.length > 1 ? value[1].name : "",
              type: "column",
              // data: value,
              data: value.length > 1 ? value[1].data : "",
            },
            {
              id: "2",
              color: "#ff0000",
              name: value.length > 0 ? value[0].name : "",
              type: "line",
              // data: target,
              data: value.length > 0 ? value[0].data : "",
            },
          ];
          this.barChartOptions = {
            
            stroke: { dashArray: value.length > 1 ? [0, 0, 0] : [0, 0] },
            yaxis: {
              title: {
                text: value[0].unit,
                style: {
                  fontSize: "14px",
                  color: "#999999",
                },
                rotate: 0,
                offsetX: 0,
                offsetY: -150,
              },
            },
          };
          this.dataBudgetDetail = value.length > 2 ? datas : datasOne;
          this.dataCheckbox = value.length > 2 ? datas : datasOne;
          this.dataTemp = value.length > 2 ? datas : datasOne;
          const item = datas.map((obj) => obj.id);
          this.isCheckedBudget = item;
          this.updateSeries();
        }
      } catch (error) {
        console.error("Error fetching data distribution budget detail:", error);
      }
    },
  },
};
</script>
<style scoped>
.custom-dropdown {
  border-radius: 0.6rem !important;
  background-color: #e6e6e6 !important;
  height: 35px;
}
.custom-dropdown:hover {
  border: 1px solid #00a3e9 !important;
}
.border-period-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.border-period-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.color-active {
  color: #fff !important;
}
.btn-disable {
  color: #999999;
  background-color: #e9e9e9;
}
.legend-items {
  display: flex;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  /* margin-right: 15px; */
}

/* .legend-symbol {
  margin-right: 5px;
} */

.line-circle {
  position: relative;
  width: 60px;
  height: 20px;
}

.line-circles {
  position: relative;
  width: 20px;
  height: 20px;
}

.line {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ff0000;
}
</style>
